
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import { mapState } from 'vuex';
    import Impfschema from '@/types/Impfschema';
    import Teilimpfungen from '@/types/Teilimpfungen';
    import Impfdosis from '@/types/Impfdosis';
    import { ValidationRules } from '@/store/types';
    import { Teilimpfungsart } from '@/types/Teilimpfungsart';

    @Component({
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('impfstoff', ['impfdosen']),
        },
    })
    export default class ImpfstoffeTeilimpfungen extends Vue {
        @Prop() teilimpfungen!: Teilimpfungen[];
        @Prop() impfschemen!: Impfschema[];
        @Prop() loading!: boolean;
        @Prop() disabled!: boolean;
        @Prop() teilimpfungsnrError!: boolean;
        @Prop() impfung!: Teilimpfungen;

        public $refs!: {
            teilimpfungen: Vue;
            text: Vue;
        };

        public rules!: ValidationRules[];
        public impfdosen!: Impfdosis[];
        public impferinnerungstextDialog = false;
        public impferinnerungstext_input: string | null = '';
        public changedTeilimpfungen = new Teilimpfungen();

        public get teilimpfungsnrClass(): string {
            return this.teilimpfungsnrError ? ' error--text' : '';
        }

        public get filteredImpfdosen(): Impfdosis[] {
            return this.impfdosen.filter((impfdosis: Impfdosis) => {
                return impfdosis.teilimpfung === 'j' || impfdosis.teilimpfungsnr === Teilimpfungsart.Auffrischung;
            });
        }

        public get tableHeight(): string | undefined {
            const count = this.teilimpfungen?.length;
            return count > 10 ? '400px' : undefined;
        }

        public get lastSchema(): string | null {
            if (this.teilimpfungen.length === 0) {
                return this.impfschemen[0]?.impfschema_code;
            }

            const codes = this.teilimpfungen.map(({ impfschema_code }) => impfschema_code);
            return this.impfschemen
                .find(({ impfschema_code }) => !codes.some((code) => code === impfschema_code))
                ?.impfschema_code ?? null;
        }

        public onClickAdd(): void {
            this.teilimpfungen.push(new Teilimpfungen());

            this.$nextTick(() => {
                const table = this.$refs.teilimpfungen.$el.firstElementChild;
                if (table) {
                    table.scrollTop = table.scrollHeight;
                }
            });
        }

        public onClickAddSchema(): void {
            const impfschema_code = this.lastSchema;
            const impfdosen = this.impfdosen;

            const teilimpfungenAnzahl = impfdosen.filter((impfdosis) => impfdosis.teilimpfung === 'j').length;
            const anzahl = Math.max(0, teilimpfungenAnzahl);

            const teilimpfungen = [...(new Array(anzahl)).keys()].map((_, idx) => {
                const teilimpfungsnr = idx + 1;
                const impfdosis = impfdosen.find((dosis: Impfdosis) => dosis.teilimpfungsnr === teilimpfungsnr);

                return new Teilimpfungen(teilimpfungsnr, {
                    impfschema_code,
                    impfdosis_code: impfdosis?.impfdosis_code ?? `D${teilimpfungsnr}`,
                    impfdb_impfartnr: impfdosis?.impfdb_impfartnr ?? teilimpfungsnr,
                });
            });

            this.teilimpfungen.push(...teilimpfungen);

            this.$nextTick(() => {
                const table = this.$refs.teilimpfungen.$el.firstElementChild;
                if (table) {
                    table.scrollTop = table.scrollHeight;
                }
            });
        }

        public onClickDeleteAll(): void {
            this.teilimpfungen.splice(0, this.teilimpfungen.length);
        }

        public onClickDelete(teilimpfung: Teilimpfungen): void {
            const index = this.teilimpfungen.indexOf(teilimpfung);
            this.teilimpfungen.splice(index, 1);
        }

        public onClickCopy(teilimpfung: Teilimpfungen): void {
            const copy = Object.assign(new Teilimpfungen(), {
                ...teilimpfung,
                teilimpfung_id: null,
                isPersistent: undefined,
            });

            this.teilimpfungen.push(copy);
        }

        public get textLabelClass(): string {
            return this.teilimpfungsnrClass === ''
                ? 'primary--text'
                : 'red--text';
        }

        public ellipsis(html: string): string {
            const div = document.createElement('div');
            div.innerHTML = html;

            const stripped = div.textContent ?? div.innerText ?? '';
            const maxLength = 15;

            return stripped.length > maxLength
                ? (stripped.substr(0, maxLength) + '...')
                : stripped;
        }

        public onClickUebernehmen() {
            this.impferinnerungstextDialog = false;
            this.changedTeilimpfungen.impferinnerungstext = this.impferinnerungstext_input;
        }

        public onClickAbbrechen() {
            this.impferinnerungstextDialog = false;
        }

        public onClickTeilimpfungserinnerungstext(teilimpfung: Teilimpfungen): void {
            this.impferinnerungstextDialog = true;
            this.changedTeilimpfungen = teilimpfung;
            this.impferinnerungstext_input = teilimpfung.impferinnerungstext;
        }
    }
